// Translations for Amanah by Zakat.International
import { translationsExt } from './translationsExt';
import { translationsV2 } from './translationsV2';
import { translationsV2Extra } from './translationsV2Extra';
import { translationsV2Menu } from './translationsV2Menu';
import { translationsSuccession } from './translationsSuccession';

export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      calculator: 'Zakat Calculator',
      rulings: 'Rulings',
      giving: 'Giving',
      faq: 'FAQ',
      language: 'Language',
      logoTitle: 'Amanah by Zakat.International', learn: 'Learn', laws: 'Laws', women: 'Women'
    },
    // Hero
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'Amanah by Zakat.International',
      subtitle: 'Universal Zakat Calculator',
      description: 'Calculate your zakat obligation with precision across multiple countries, currencies, and personal circumstances.',
      startCalculator: 'Start Calculator',
      learnMore: 'Learn More'
    },
    // Stats Bar
    stats: {
      goldNisab: 'Gold Nisab',
      silverNisab: 'Silver Nisab',
      zakatRate: 'Zakat Rate',
      grams: 'grams',
      livePrice: 'Live Price'
    },
    // Person Types
    personTypes: {
      title: 'Select Your Category',
      subtitle: 'Choose your situation for personalized calculation',
      salaried: 'Salaried Employee',
      salariedDesc: 'Regular income from employment',
      selfEmployed: 'Self-Employed',
      selfEmployedDesc: 'Freelancer or consultant',
      businessOwner: 'Business Owner',
      businessOwnerDesc: 'Retail, hotel, or services',
      investor: 'Investor',
      investorDesc: 'Stocks, mutual funds, crypto',
      farmer: 'Farmer',
      farmerDesc: 'Agricultural income',
      retiree: 'Retiree',
      retireeDesc: 'Pension and savings',
      student: 'Student',
      studentDesc: 'Savings and scholarships',
      women: 'Women/Ladies',
      womenDesc: 'Jewellery and mahr',
      landlord: 'Landlord',
      landlordDesc: 'Rental income',
      crypto: 'Crypto Holder',
      cryptoDesc: 'Digital assets',
      livestock: 'Livestock Owner',
      livestockDesc: 'Animals and produce',
      professional: 'Professional',
      professionalDesc: 'Doctor, lawyer, etc.'
    },
    // Calculator Steps
    calculator: {
      step1: 'Select Type',
      step2: 'Enter Assets',
      step3: 'Deductions',
      step4: 'Results',
      next: 'Next',
      back: 'Back',
      calculate: 'Calculate Zakat',
      reset: 'Reset',
      // Asset labels
      gold: 'Gold',
      silver: 'Silver',
      cash: 'Cash & Savings',
      investments: 'Investments',
      business: 'Business Assets',
      crypto: 'Cryptocurrency',
      livestock: 'Livestock',
      agriculture: 'Agricultural',
      pension: 'Pension',
      jewellery: 'Jewellery',
      receivables: 'Receivables',
      inventory: 'Inventory',
      // Deduction labels
      debts: 'Personal Debts',
      expenses: 'Essential Expenses',
      liabilities: 'Business Liabilities'
    },
    // Results
    results: {
      totalAssets: 'Total Assets',
      totalDeductions: 'Total Deductions',
      netZakatable: 'Net Zakatable Wealth',
      nisabThreshold: 'Nisab Threshold',
      zakatDue: 'Zakat Due',
      eligible: 'Zakat is obligatory',
      notEligible: 'Below Nisab threshold',
      breakdown: 'Breakdown',
      downloadReport: 'Download Report',
      shareResult: 'Share Result'
    },
    // Rulings
    rulings: {
      title: 'Scholarly Rulings',
      subtitle: 'Different schools of thought on Zakat',
      hanafi: 'Hanafi',
      maliki: 'Maliki',
      shafii: "Shafi'i",
      hanbali: 'Hanbali',
      aaoifi: 'AAOIFI Standard',
      contemporary: 'Contemporary Scholars'
    },
    // FAQ
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'Is zakat due on women\'s jewellery?',
      a1: 'According to Hanafi school, zakat is due on gold/silver jewellery if it reaches nisab. Other schools exempt jewellery worn regularly.',
      q2: 'How to calculate zakat on pension funds?',
      a2: 'For accessible pension funds, zakat is due on the full amount. For locked funds (like EPF), zakat is due when withdrawn.',
      q3: 'Is cryptocurrency subject to zakat?',
      a3: 'Yes, cryptocurrency is treated as tradeable goods. Zakat is due at market value if held for one lunar year.',
      q4: 'Should I use gold or silver nisab?',
      a4: 'Scholars recommend using silver nisab to benefit more poor people. However, gold nisab is also valid.',
      q5: 'How do business partners calculate zakat?',
      a5: 'Each partner calculates zakat on their share of the business assets after deducting their share of liabilities.'
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      perGram: 'per gram',
      total: 'Total',
      currency: 'Currency',
      country: 'Country',
      selectCountry: 'Select Country',
      selectLanguage: 'Select Language',
      step: 'Step',
      quickAnswer: 'Quick Answer',
      directSummary: 'Direct summary'
    },
    steps: {
      estate: 'Estate',
      deductions: 'Deductions',
      heirs: 'Heirs',
      result: 'Result'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      calculator: 'حاسبة الزكاة',
      rulings: 'الأحكام',
      giving: 'التوزيع',
      faq: 'الأسئلة',
      language: 'اللغة',
      logoTitle: 'زكاة إنترناشونال', learn: 'تعلّم', laws: 'قوانين', women: 'المرأة'
    },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'زكاة عالمي',
      subtitle: 'حاسبة الزكاة الشاملة',
      description: 'احسب زكاتك بدقة عبر دول وعملات ومواقف متعددة',
      startCalculator: 'ابدأ الحساب',
      learnMore: 'معرفة المزيد'
    },
    stats: {
      goldNisab: 'نصاب الذهب',
      silverNisab: 'نصاب الفضة',
      zakatRate: 'معدل الزكاة',
      grams: 'جرام',
      livePrice: 'السعر الحالي'
    },
    personTypes: {
      title: 'اختر فئتك',
      subtitle: 'اختر وضعك للحساب المخصص',
      salaried: 'موظف براتب',
      salariedDesc: 'دخل منتظم من العمل',
      selfEmployed: 'عمل حر',
      selfEmployedDesc: 'مستقل أو مستشار',
      businessOwner: 'صاحب عمل',
      businessOwnerDesc: 'تجزئة أو فندق أو خدمات',
      investor: 'مستثمر',
      investorDesc: 'أسهم، صناديق، عملات رقمية',
      farmer: 'مزارع',
      farmerDesc: 'دخل زراعي',
      retiree: 'متقاعد',
      retireeDesc: 'معاش ومدخرات',
      student: 'طالب',
      studentDesc: 'مدخرات ومنح',
      women: 'نساء/سيدات',
      womenDesc: 'مجوهرات ومهر',
      landlord: 'مالك عقار',
      landlordDesc: 'دخل إيجاري',
      crypto: 'مالك عملات رقمية',
      cryptoDesc: 'أصول رقمية',
      livestock: 'مالك ماشية',
      livestockDesc: 'حيوانات ومنتجات',
      professional: 'مهني',
      professionalDesc: 'طبيب، محامي، إلخ'
    },
    calculator: {
      step1: 'اختر النوع',
      step2: 'أدخل الأصول',
      step3: 'الخصومات',
      step4: 'النتائج',
      next: 'التالي',
      back: 'رجوع',
      calculate: 'احسب الزكاة',
      reset: 'إعادة',
      gold: 'الذهب',
      silver: 'الفضة',
      cash: 'النقد والمدخرات',
      investments: 'الاستثمارات',
      business: 'أصول العمل',
      crypto: 'العملات الرقمية',
      livestock: 'الماشية',
      agriculture: 'الزراعة',
      pension: 'التقاعد',
      jewellery: 'المجوهرات',
      receivables: 'المستحقات',
      inventory: 'المخزون',
      debts: 'الديون الشخصية',
      expenses: 'المصاريف الأساسية',
      liabilities: 'التزامات العمل'
    },
    results: {
      totalAssets: 'إجمالي الأصول',
      totalDeductions: 'إجمالي الخصومات',
      netZakatable: 'صافي المال الزكوي',
      nisabThreshold: 'حد النصاب',
      zakatDue: 'الزكاة المستحقة',
      eligible: 'الزكاة واجبة',
      notEligible: 'أقل من النصاب',
      breakdown: 'التفصيل',
      downloadReport: 'تحميل التقرير',
      shareResult: 'مشاركة النتيجة'
    },
    rulings: {
      title: 'الأحكام الفقهية',
      subtitle: 'المذاهب المختلفة في الزكاة',
      hanafi: 'الحنفي',
      maliki: 'المالكي',
      shafii: 'الشافعي',
      hanbali: 'الحنبلي',
      aaoifi: 'معيار أيوفي',
      contemporary: 'العلماء المعاصرون'
    },
    faq: {
      title: 'الأسئلة الشائعة',
      q1: 'هل تجب الزكاة في حلي النساء؟',
      a1: 'عند الحنفية تجب الزكاة في حلي الذهب والفضة إذا بلغت النصاب. المذاهب الأخرى تعفي الحلي المستعملة.',
      q2: 'كيف تحسب زكاة صناديق التقاعد؟',
      a2: 'للأموال المتاحة تجب الزكاة على كامل المبلغ. للأموال المقيدة تجب عند السحب.',
      q3: 'هل تجب الزكاة في العملات الرقمية؟',
      a3: 'نعم، تعامل كعروض تجارة. تجب الزكاة بالقيمة السوقية إذا حال عليها الحول.',
      q4: 'أستخدم نصاب الذهب أم الفضة؟',
      a4: 'يوصي العلماء بنصاب الفضة لمصلحة الفقراء. لكن نصاب الذهب صحيح أيضاً.',
      q5: 'كيف يحسب الشركاء زكاتهم؟',
      a5: 'كل شريك يحسب زكاته على حصته من الأصول بعد خصم حصته من الالتزامات.'
    },
    common: {
      loading: 'جاري التحميل...',
      error: 'خطأ',
      perGram: 'للجرام',
      total: 'المجموع',
      currency: 'العملة',
      country: 'البلد',
      selectCountry: 'اختر البلد',
      selectLanguage: 'اختر اللغة',
      step: 'خطوة',
      quickAnswer: 'إجابة سريعة',
      directSummary: 'ملخّص مباشر'
    },
    steps: {
      estate: 'التركة',
      deductions: 'الاستقطاعات',
      heirs: 'الورثة',
      result: 'النتيجة'
    }
  },
  ur: {
    nav: {
      home: 'ہوم',
      calculator: 'کیلکولیٹر',
      rulings: 'احکام',
      giving: 'ادائیگی',
      faq: 'سوالات',
      language: 'زبان',
      logoTitle: 'زکوٰۃ انٹرنیشنل', learn: 'سیکھیں', laws: 'قوانین', women: 'خواتین'
    },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'زکات گلوبل',
      subtitle: 'عالمی زکات کیلکولیٹر',
      description: 'مختلف ممالک، کرنسیوں اور ذاتی حالات کے مطابق اپنی زکات کا درست حساب لگائیں',
      startCalculator: 'کیلکولیٹر شروع کریں',
      learnMore: 'مزید جانیں'
    },
    stats: {
      goldNisab: 'سونے کا نصاب',
      silverNisab: 'چاندی کا نصاب',
      zakatRate: 'زکات کی شرح',
      grams: 'گرام',
      livePrice: 'موجودہ قیمت'
    },
    personTypes: {
      title: 'اپنی قسم منتخب کریں',
      subtitle: 'ذاتی حساب کے لیے اپنی صورتحال چنیں',
      salaried: 'تنخواہ دار',
      salariedDesc: 'ملازمت سے باقاعدہ آمدنی',
      selfEmployed: 'خود ملازم',
      selfEmployedDesc: 'فری لانسر یا مشیر',
      businessOwner: 'کاروباری',
      businessOwnerDesc: 'ریٹیل، ہوٹل، یا خدمات',
      investor: 'سرمایہ کار',
      investorDesc: 'اسٹاک، فنڈز، کرپٹو',
      farmer: 'کسان',
      farmerDesc: 'زرعی آمدنی',
      retiree: 'ریٹائرڈ',
      retireeDesc: 'پنشن اور بچت',
      student: 'طالب علم',
      studentDesc: 'بچت اور وظائف',
      women: 'خواتین',
      womenDesc: 'زیورات اور مہر',
      landlord: 'جائیداد مالک',
      landlordDesc: 'کرایہ کی آمدنی',
      crypto: 'کرپٹو مالک',
      cryptoDesc: 'ڈیجیٹل اثاثے',
      livestock: 'مویشی مالک',
      livestockDesc: 'جانور اور پیداوار',
      professional: 'پیشہ ور',
      professionalDesc: 'ڈاکٹر، وکیل، وغیرہ'
    },
    calculator: {
      step1: 'قسم چنیں',
      step2: 'اثاثے درج کریں',
      step3: 'کٹوتیاں',
      step4: 'نتائج',
      next: 'اگلا',
      back: 'واپس',
      calculate: 'زکات کا حساب',
      reset: 'ری سیٹ',
      gold: 'سونا',
      silver: 'چاندی',
      cash: 'نقد اور بچت',
      investments: 'سرمایہ کاری',
      business: 'کاروباری اثاثے',
      crypto: 'کرپٹو کرنسی',
      livestock: 'مویشی',
      agriculture: 'زراعت',
      pension: 'پنشن',
      jewellery: 'زیورات',
      receivables: 'قابل وصول',
      inventory: 'انوینٹری',
      debts: 'ذاتی قرض',
      expenses: 'ضروری اخراجات',
      liabilities: 'کاروباری واجبات'
    },
    results: {
      totalAssets: 'کل اثاثے',
      totalDeductions: 'کل کٹوتیاں',
      netZakatable: 'خالص قابل زکات',
      nisabThreshold: 'نصاب کی حد',
      zakatDue: 'واجب زکات',
      eligible: 'زکات فرض ہے',
      notEligible: 'نصاب سے کم',
      breakdown: 'تفصیل',
      downloadReport: 'رپورٹ ڈاؤنلوڈ',
      shareResult: 'نتیجہ شیئر کریں'
    },
    rulings: {
      title: 'فقہی احکام',
      subtitle: 'زکات پر مختلف مکاتب فکر',
      hanafi: 'حنفی',
      maliki: 'مالکی',
      shafii: 'شافعی',
      hanbali: 'حنبلی',
      aaoifi: 'اے اے او آئی ایف آئی',
      contemporary: 'معاصر علماء'
    },
    faq: {
      title: 'عام سوالات',
      q1: 'کیا خواتین کے زیورات پر زکات ہے؟',
      a1: 'حنفی مذہب میں سونے چاندی کے زیورات پر نصاب پورا ہونے پر زکات واجب ہے۔ دوسرے مذاہب روزانہ پہننے والے زیورات معاف کرتے ہیں۔',
      q2: 'پنشن فنڈ پر زکات کا حساب کیسے؟',
      a2: 'دستیاب پنشن پر پوری رقم پر زکات واجب ہے۔ مقفل فنڈز پر نکالتے وقت زکات دیں۔',
      q3: 'کیا کرپٹو کرنسی پر زکات ہے؟',
      a3: 'ہاں، یہ تجارتی مال کی طرح ہے۔ سال پورا ہونے پر مارکیٹ قیمت پر زکات واجب ہے۔',
      q4: 'سونے یا چاندی کا نصاب استعمال کروں؟',
      a4: 'علماء غریبوں کی مصلحت میں چاندی کا نصاب تجویز کرتے ہیں۔ سونے کا نصاب بھی درست ہے۔',
      q5: 'شراکت دار زکات کیسے نکالیں؟',
      a5: 'ہر شراکت دار اپنے حصے کے اثاثوں پر واجبات نکال کر زکات دے۔'
    },
    common: {
      loading: 'لوڈ ہو رہا ہے...',
      error: 'خرابی',
      perGram: 'فی گرام',
      total: 'کل',
      currency: 'کرنسی',
      country: 'ملک',
      selectCountry: 'ملک منتخب کریں',
      selectLanguage: 'زبان منتخب کریں',
      step: 'مرحلہ',
      quickAnswer: 'فوری جواب',
      directSummary: 'براہ راست خلاصہ'
    },
    steps: {
      estate: 'ترکہ',
      deductions: 'کٹوتیاں',
      heirs: 'وارثین',
      result: 'نتیجہ'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      calculator: 'Calculateur de Zakat',
      rulings: 'Règles',
      giving: 'Distribution',
      faq: 'FAQ',
      language: 'Langue',
      logoTitle: 'Amanah by Zakat.International', learn: 'Apprendre', laws: 'Lois', women: 'Femmes'
    },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'Amanah by Zakat.International',
      subtitle: 'Calculateur de Zakat Universel',
      description: 'Calculez votre obligation de zakat avec précision dans plusieurs pays et devises.',
      startCalculator: 'Commencer',
      learnMore: 'En savoir plus'
    },
    stats: {
      goldNisab: 'Nisab Or',
      silverNisab: 'Nisab Argent',
      zakatRate: 'Taux de Zakat',
      grams: 'grammes',
      livePrice: 'Prix actuel'
    },
    personTypes: {
      title: 'Sélectionnez votre catégorie',
      subtitle: 'Choisissez votre situation pour un calcul personnalisé',
      salaried: 'Salarié',
      salariedDesc: 'Revenu régulier',
      selfEmployed: 'Indépendant',
      selfEmployedDesc: 'Freelance ou consultant',
      businessOwner: 'Chef d\'entreprise',
      businessOwnerDesc: 'Commerce ou services',
      investor: 'Investisseur',
      investorDesc: 'Actions, fonds, crypto',
      farmer: 'Agriculteur',
      farmerDesc: 'Revenu agricole',
      retiree: 'Retraité',
      retireeDesc: 'Pension et épargne',
      student: 'Étudiant',
      studentDesc: 'Épargne et bourses',
      women: 'Femmes',
      womenDesc: 'Bijoux et mahr',
      landlord: 'Propriétaire',
      landlordDesc: 'Revenus locatifs',
      crypto: 'Détenteur Crypto',
      cryptoDesc: 'Actifs numériques',
      livestock: 'Éleveur',
      livestockDesc: 'Bétail et produits',
      professional: 'Professionnel',
      professionalDesc: 'Médecin, avocat, etc.'
    },
    calculator: {
      step1: 'Type',
      step2: 'Actifs',
      step3: 'Déductions',
      step4: 'Résultats',
      next: 'Suivant',
      back: 'Retour',
      calculate: 'Calculer',
      reset: 'Réinitialiser',
      gold: 'Or',
      silver: 'Argent',
      cash: 'Liquidités',
      investments: 'Investissements',
      business: 'Actifs commerciaux',
      crypto: 'Cryptomonnaie',
      livestock: 'Bétail',
      agriculture: 'Agriculture',
      pension: 'Retraite',
      jewellery: 'Bijoux',
      receivables: 'Créances',
      inventory: 'Stock',
      debts: 'Dettes',
      expenses: 'Dépenses essentielles',
      liabilities: 'Passif commercial'
    },
    results: {
      totalAssets: 'Total des actifs',
      totalDeductions: 'Total des déductions',
      netZakatable: 'Richesse nette imposable',
      nisabThreshold: 'Seuil de Nisab',
      zakatDue: 'Zakat due',
      eligible: 'Zakat obligatoire',
      notEligible: 'Sous le seuil de Nisab',
      breakdown: 'Détails',
      downloadReport: 'Télécharger',
      shareResult: 'Partager'
    },
    rulings: {
      title: 'Règles juridiques',
      subtitle: 'Différentes écoles de pensée',
      hanafi: 'Hanafi',
      maliki: 'Maliki',
      shafii: "Shafi'i",
      hanbali: 'Hanbali',
      aaoifi: 'Standard AAOIFI',
      contemporary: 'Savants contemporains'
    },
    faq: {
      title: 'Questions fréquentes',
      q1: 'La zakat est-elle due sur les bijoux des femmes?',
      a1: 'Selon l\'école Hanafi, la zakat est due sur les bijoux en or/argent si le nisab est atteint.',
      q2: 'Comment calculer la zakat sur les fonds de pension?',
      a2: 'Pour les fonds accessibles, la zakat est due sur le montant total.',
      q3: 'La cryptomonnaie est-elle soumise à la zakat?',
      a3: 'Oui, traitée comme des marchandises commerciales.',
      q4: 'Dois-je utiliser le nisab or ou argent?',
      a4: 'Les savants recommandent le nisab argent pour aider plus de pauvres.',
      q5: 'Comment les associés calculent-ils la zakat?',
      a5: 'Chaque associé calcule sur sa part des actifs après déduction des passifs.'
    },
    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      perGram: 'par gramme',
      total: 'Total',
      currency: 'Devise',
      country: 'Pays',
      selectCountry: 'Sélectionner le pays',
      selectLanguage: 'Sélectionner la langue',
      step: 'Étape',
      quickAnswer: 'Réponse rapide',
      directSummary: 'Résumé direct'
    },
    steps: {
      estate: 'Succession',
      deductions: 'Déductions',
      heirs: 'Héritiers',
      result: 'Résultat'
    }
  },
  ms: {
    nav: {
      home: 'Utama',
      calculator: 'Kalkulator Zakat',
      rulings: 'Hukum',
      giving: 'Agihan',
      faq: 'FAQ',
      language: 'Bahasa',
      logoTitle: 'Amanah by Zakat.International', learn: 'Belajar', laws: 'Undang-undang', women: 'Wanita'
    },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'Amanah by Zakat.International',
      subtitle: 'Kalkulator Zakat Universal',
      description: 'Kira zakat anda dengan tepat merentasi pelbagai negara dan mata wang.',
      startCalculator: 'Mula Kira',
      learnMore: 'Ketahui Lebih'
    },
    stats: {
      goldNisab: 'Nisab Emas',
      silverNisab: 'Nisab Perak',
      zakatRate: 'Kadar Zakat',
      grams: 'gram',
      livePrice: 'Harga Semasa'
    },
    personTypes: {
      title: 'Pilih Kategori Anda',
      subtitle: 'Pilih situasi anda untuk pengiraan khusus',
      salaried: 'Bergaji',
      salariedDesc: 'Pendapatan tetap',
      selfEmployed: 'Bekerja Sendiri',
      selfEmployedDesc: 'Freelancer atau perunding',
      businessOwner: 'Pemilik Perniagaan',
      businessOwnerDesc: 'Runcit, hotel, perkhidmatan',
      investor: 'Pelabur',
      investorDesc: 'Saham, dana, kripto',
      farmer: 'Petani',
      farmerDesc: 'Pendapatan pertanian',
      retiree: 'Pesara',
      retireeDesc: 'Pencen dan simpanan',
      student: 'Pelajar',
      studentDesc: 'Simpanan dan biasiswa',
      women: 'Wanita',
      womenDesc: 'Barang kemas dan mahar',
      landlord: 'Tuan Tanah',
      landlordDesc: 'Pendapatan sewa',
      crypto: 'Pemegang Kripto',
      cryptoDesc: 'Aset digital',
      livestock: 'Penternak',
      livestockDesc: 'Ternakan dan hasil',
      professional: 'Profesional',
      professionalDesc: 'Doktor, peguam, dll.'
    },
    calculator: {
      step1: 'Pilih Jenis',
      step2: 'Masuk Aset',
      step3: 'Potongan',
      step4: 'Keputusan',
      next: 'Seterusnya',
      back: 'Kembali',
      calculate: 'Kira Zakat',
      reset: 'Set Semula',
      gold: 'Emas',
      silver: 'Perak',
      cash: 'Tunai & Simpanan',
      investments: 'Pelaburan',
      business: 'Aset Perniagaan',
      crypto: 'Mata Wang Kripto',
      livestock: 'Ternakan',
      agriculture: 'Pertanian',
      pension: 'Pencen',
      jewellery: 'Barang Kemas',
      receivables: 'Hutang Piutang',
      inventory: 'Inventori',
      debts: 'Hutang Peribadi',
      expenses: 'Perbelanjaan Asas',
      liabilities: 'Liabiliti Perniagaan'
    },
    results: {
      totalAssets: 'Jumlah Aset',
      totalDeductions: 'Jumlah Potongan',
      netZakatable: 'Kekayaan Bersih',
      nisabThreshold: 'Had Nisab',
      zakatDue: 'Zakat Wajib',
      eligible: 'Zakat wajib dibayar',
      notEligible: 'Di bawah nisab',
      breakdown: 'Pecahan',
      downloadReport: 'Muat Turun',
      shareResult: 'Kongsi'
    },
    rulings: {
      title: 'Hukum Fiqh',
      subtitle: 'Mazhab berbeza tentang zakat',
      hanafi: 'Hanafi',
      maliki: 'Maliki',
      shafii: "Syafi'i",
      hanbali: 'Hanbali',
      aaoifi: 'Standard AAOIFI',
      contemporary: 'Ulama Kontemporari'
    },
    faq: {
      title: 'Soalan Lazim',
      q1: 'Adakah zakat wajib ke atas barang kemas wanita?',
      a1: 'Menurut mazhab Hanafi, zakat wajib ke atas barang kemas emas/perak jika mencapai nisab.',
      q2: 'Bagaimana mengira zakat dana pencen?',
      a2: 'Untuk dana yang boleh diakses, zakat wajib ke atas jumlah penuh.',
      q3: 'Adakah mata wang kripto tertakluk kepada zakat?',
      a3: 'Ya, dianggap sebagai barang dagangan.',
      q4: 'Patut guna nisab emas atau perak?',
      a4: 'Ulama mencadangkan nisab perak untuk membantu lebih ramai fakir miskin.',
      q5: 'Bagaimana rakan kongsi mengira zakat?',
      a5: 'Setiap rakan kongsi mengira zakat ke atas bahagian aset selepas menolak liabiliti.'
    },
    common: {
      loading: 'Memuatkan...',
      error: 'Ralat',
      perGram: 'setiap gram',
      total: 'Jumlah',
      currency: 'Mata Wang',
      country: 'Negara',
      selectCountry: 'Pilih Negara',
      selectLanguage: 'Pilih Bahasa',
      step: 'Langkah',
      quickAnswer: 'Jawapan Pantas',
      directSummary: 'Ringkasan langsung'
    },
    steps: {
      estate: 'Harta pusaka',
      deductions: 'Potongan',
      heirs: 'Waris',
      result: 'Keputusan'
    }
  },
  tr: {
    nav: {
      home: 'Ana Sayfa',
      calculator: 'Zekât Hesaplayıcı',
      rulings: 'Fıkhi Hükümler',
      giving: 'Dağıtım',
      faq: 'SSS',
      language: 'Dil',
      logoTitle: 'Amanah by Zakat.International', learn: 'Öğren', laws: 'Kanunlar', women: 'Kadınlar'
    },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'Amanah by Zakat.International',
      subtitle: 'Evrensel Zekât Hesaplayıcı',
      description: 'Zekât yükümlülüğünüzü farklı ülkeler, para birimleri ve kişisel durumlar için hassas şekilde hesaplayın.',
      startCalculator: 'Hesaplayıcıyı Başlat',
      learnMore: 'Daha Fazla Bilgi'
    },
    stats: {
      goldNisab: 'Altın Nisabı',
      silverNisab: 'Gümüş Nisabı',
      zakatRate: 'Zekât Oranı',
      grams: 'gram',
      livePrice: 'Anlık Fiyat'
    },
    personTypes: {
      title: 'Kategorinizi Seçin',
      subtitle: 'Kişiselleştirilmiş hesaplama için durumunuzu seçin',
      salaried: 'Maaşlı Çalışan',
      salariedDesc: 'Düzenli iş geliri',
      selfEmployed: 'Serbest Meslek',
      selfEmployedDesc: 'Freelancer veya danışman',
      businessOwner: 'İşletme Sahibi',
      businessOwnerDesc: 'Perakende, otel veya hizmetler',
      investor: 'Yatırımcı',
      investorDesc: 'Hisse, fon, kripto',
      farmer: 'Çiftçi',
      farmerDesc: 'Tarımsal gelir',
      retiree: 'Emekli',
      retireeDesc: 'Emekli maaşı ve birikim',
      student: 'Öğrenci',
      studentDesc: 'Birikim ve burslar',
      women: 'Kadınlar',
      womenDesc: 'Mücevher ve mehir',
      landlord: 'Mülk Sahibi',
      landlordDesc: 'Kira geliri',
      crypto: 'Kripto Sahibi',
      cryptoDesc: 'Dijital varlıklar',
      livestock: 'Hayvan Sahibi',
      livestockDesc: 'Hayvanlar ve ürünleri',
      professional: 'Profesyonel',
      professionalDesc: 'Doktor, avukat vb.'
    },
    calculator: {
      step1: 'Tür Seç',
      step2: 'Varlıkları Gir',
      step3: 'Kesintiler',
      step4: 'Sonuç',
      next: 'İleri',
      back: 'Geri',
      calculate: 'Zekâtı Hesapla',
      reset: 'Sıfırla',
      gold: 'Altın',
      silver: 'Gümüş',
      cash: 'Nakit ve Birikim',
      investments: 'Yatırımlar',
      business: 'İş Varlıkları',
      crypto: 'Kripto Para',
      livestock: 'Hayvanlar',
      agriculture: 'Tarım',
      pension: 'Emeklilik',
      jewellery: 'Mücevherat',
      receivables: 'Alacaklar',
      inventory: 'Stok',
      debts: 'Kişisel Borçlar',
      expenses: 'Temel Giderler',
      liabilities: 'İşletme Yükümlülükleri'
    },
    results: {
      totalAssets: 'Toplam Varlıklar',
      totalDeductions: 'Toplam Kesintiler',
      netZakatable: 'Net Zekâta Tabi Servet',
      nisabThreshold: 'Nisab Eşiği',
      zakatDue: 'Ödenecek Zekât',
      eligible: 'Zekât farzdır',
      notEligible: 'Nisabın altında',
      breakdown: 'Detay',
      downloadReport: 'Raporu İndir',
      shareResult: 'Sonucu Paylaş'
    },
    rulings: {
      title: 'Fıkhi Hükümler',
      subtitle: 'Zekât konusunda farklı mezhep görüşleri',
      hanafi: 'Hanefî',
      maliki: 'Mâlikî',
      shafii: 'Şâfiî',
      hanbali: 'Hanbelî',
      aaoifi: 'AAOIFI Standardı',
      contemporary: 'Çağdaş Âlimler'
    },
    faq: {
      title: 'Sıkça Sorulan Sorular',
      q1: 'Kadın mücevherlerine zekât düşer mi?',
      a1: 'Hanefî mezhebine göre altın/gümüş takılar nisaba ulaştığında zekât gerekir. Diğer mezhepler düzenli takılan takıları muaf tutar.',
      q2: 'Emeklilik fonlarının zekâtı nasıl hesaplanır?',
      a2: 'Erişilebilir emeklilik fonları için zekât tam tutar üzerindendir. Kilitli fonlar için (örn. SGK) zekât çekildiğinde verilir.',
      q3: 'Kripto para zekâta tabi midir?',
      a3: 'Evet, kripto para ticari mal olarak değerlendirilir. Bir kameri yıl elde tutulursa piyasa değeri üzerinden zekât verilir.',
      q4: 'Altın nisabını mı gümüş nisabını mı kullanmalıyım?',
      a4: 'Âlimler daha fazla fakire yardım için gümüş nisabını tavsiye eder. Ancak altın nisabı da geçerlidir.',
      q5: 'Ortaklar zekâtı nasıl hesaplar?',
      a5: 'Her ortak, yükümlülüklerden kendi payı düşüldükten sonra iş varlıklarındaki payı üzerinden zekâtını hesaplar.'
    },
    common: {
      loading: 'Yükleniyor...',
      error: 'Hata',
      perGram: 'gram başına',
      total: 'Toplam',
      currency: 'Para Birimi',
      country: 'Ülke',
      selectCountry: 'Ülke Seçin',
      selectLanguage: 'Dil Seçin',
      step: 'Adım',
      quickAnswer: 'Hızlı Yanıt',
      directSummary: 'Doğrudan özet'
    },
    steps: {
      estate: 'Miras',
      deductions: 'İndirimler',
      heirs: 'Varisler',
      result: 'Sonuç'
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      calculator: 'Калькулятор закята',
      rulings: 'Правовые мнения',
      giving: 'Распределение',
      faq: 'Вопросы',
      language: 'Язык',
      logoTitle: 'Amanah by Zakat.International', learn: 'Учить', laws: 'Законы', women: 'Женщины'
    },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'Amanah by Zakat.International',
      subtitle: 'Универсальный калькулятор закята',
      description: 'Точно рассчитайте свой закят с учётом стран, валют и личных обстоятельств.',
      startCalculator: 'Начать расчёт',
      learnMore: 'Подробнее'
    },
    stats: {
      goldNisab: 'Нисаб золота',
      silverNisab: 'Нисаб серебра',
      zakatRate: 'Ставка закята',
      grams: 'грамм',
      livePrice: 'Текущая цена'
    },
    personTypes: {
      title: 'Выберите вашу категорию',
      subtitle: 'Выберите свою ситуацию для персонализированного расчёта',
      salaried: 'Наёмный работник',
      salariedDesc: 'Регулярный доход с работы',
      selfEmployed: 'Самозанятый',
      selfEmployedDesc: 'Фрилансер или консультант',
      businessOwner: 'Владелец бизнеса',
      businessOwnerDesc: 'Розница, отель или услуги',
      investor: 'Инвестор',
      investorDesc: 'Акции, фонды, криптовалюта',
      farmer: 'Фермер',
      farmerDesc: 'Сельскохозяйственный доход',
      retiree: 'Пенсионер',
      retireeDesc: 'Пенсия и сбережения',
      student: 'Студент',
      studentDesc: 'Сбережения и стипендии',
      women: 'Женщины',
      womenDesc: 'Украшения и махр',
      landlord: 'Арендодатель',
      landlordDesc: 'Доход от аренды',
      crypto: 'Держатель крипты',
      cryptoDesc: 'Цифровые активы',
      livestock: 'Скотовод',
      livestockDesc: 'Животные и продукция',
      professional: 'Специалист',
      professionalDesc: 'Врач, юрист и др.'
    },
    calculator: {
      step1: 'Выбор типа',
      step2: 'Активы',
      step3: 'Вычеты',
      step4: 'Результаты',
      next: 'Далее',
      back: 'Назад',
      calculate: 'Рассчитать закят',
      reset: 'Сбросить',
      gold: 'Золото',
      silver: 'Серебро',
      cash: 'Наличные и сбережения',
      investments: 'Инвестиции',
      business: 'Бизнес-активы',
      crypto: 'Криптовалюта',
      livestock: 'Скот',
      agriculture: 'Сельское хозяйство',
      pension: 'Пенсия',
      jewellery: 'Украшения',
      receivables: 'Дебиторская задолженность',
      inventory: 'Товарные запасы',
      debts: 'Личные долги',
      expenses: 'Необходимые расходы',
      liabilities: 'Обязательства бизнеса'
    },
    results: {
      totalAssets: 'Всего активов',
      totalDeductions: 'Всего вычетов',
      netZakatable: 'Чистая сумма для закята',
      nisabThreshold: 'Порог нисаба',
      zakatDue: 'Закят к выплате',
      eligible: 'Закят обязателен',
      notEligible: 'Ниже порога нисаба',
      breakdown: 'Детализация',
      downloadReport: 'Скачать отчёт',
      shareResult: 'Поделиться'
    },
    rulings: {
      title: 'Мнения учёных',
      subtitle: 'Разные мазхабы о закяте',
      hanafi: 'Ханафи',
      maliki: 'Малики',
      shafii: 'Шафии',
      hanbali: 'Ханбали',
      aaoifi: 'Стандарт AAOIFI',
      contemporary: 'Современные учёные'
    },
    faq: {
      title: 'Часто задаваемые вопросы',
      q1: 'Платится ли закят с женских украшений?',
      a1: 'Согласно ханафитскому мазхабу, закят обязателен с золотых/серебряных украшений, если они достигают нисаба. Другие мазхабы освобождают украшения, носимые регулярно.',
      q2: 'Как рассчитать закят с пенсионных накоплений?',
      a2: 'С доступных пенсионных фондов закят берётся с полной суммы. С заблокированных средств — при их получении.',
      q3: 'Облагается ли криптовалюта закятом?',
      a3: 'Да, криптовалюта приравнивается к торговому товару. Закят выплачивается с рыночной стоимости, если активы хранились лунный год.',
      q4: 'Какой нисаб использовать — золотой или серебряный?',
      a4: 'Учёные рекомендуют серебряный нисаб, чтобы помочь большему числу нуждающихся. Однако золотой нисаб также допустим.',
      q5: 'Как партнёры по бизнесу рассчитывают закят?',
      a5: 'Каждый партнёр рассчитывает закят со своей доли активов после вычета своей доли обязательств.'
    },
    common: {
      loading: 'Загрузка...',
      error: 'Ошибка',
      perGram: 'за грамм',
      total: 'Итого',
      currency: 'Валюта',
      country: 'Страна',
      selectCountry: 'Выберите страну',
      selectLanguage: 'Выберите язык',
      step: 'Шаг',
      quickAnswer: 'Быстрый ответ',
      directSummary: 'Прямое резюме'
    },
    steps: {
      estate: 'Имущество',
      deductions: 'Вычеты',
      heirs: 'Наследники',
      result: 'Результат'
    }
  },

  // ---------- Feb 2026 — Partial translations. Falls back to English for unmapped keys. ----------
  hi: {
    nav: { home: 'मुख्य पृष्ठ', calculator: 'ज़कात कैलकुलेटर', rulings: 'फ़तवे', giving: 'दान', faq: 'सामान्य प्रश्न', language: 'भाषा' , logoTitle: 'ज़कात इंटरनेशनल', learn: 'सीखें', laws: 'क़ानून', women: 'महिलाएँ' },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'ज़कात इंटरनेशनल',
      subtitle: 'सार्वभौमिक ज़कात कैलकुलेटर',
      description: 'विभिन्न देशों, मुद्राओं और व्यक्तिगत परिस्थितियों के अनुसार अपनी ज़कात की सटीक गणना करें।',
      startCalculator: 'कैलकुलेटर शुरू करें',
      learnMore: 'और जानें',
    },
    stats: { goldNisab: 'सोने का निसाब', silverNisab: 'चांदी का निसाब', zakatRate: 'ज़कात दर', grams: 'ग्राम', livePrice: 'लाइव कीमत' },
    personTypes: {
      title: 'अपनी श्रेणी चुनें',
      subtitle: 'व्यक्तिगत गणना के लिए अपनी स्थिति चुनें',
      salaried: 'वेतनभोगी कर्मचारी', salariedDesc: 'रोज़गार से नियमित आय',
      selfEmployed: 'स्व-नियोजित', selfEmployedDesc: 'फ्रीलांसर या सलाहकार',
      businessOwner: 'व्यवसाय स्वामी', businessOwnerDesc: 'खुदरा, होटल या सेवाएँ',
      investor: 'निवेशक', investorDesc: 'शेयर, म्यूचुअल फंड, क्रिप्टो',
      farmer: 'किसान', farmerDesc: 'कृषि आय',
      retiree: 'सेवानिवृत्त', retireeDesc: 'पेंशन और बचत',
      student: 'छात्र', studentDesc: 'बचत और छात्रवृत्तियाँ',
      women: 'महिलाएँ', womenDesc: 'आभूषण और महर',
      landlord: 'मकान मालिक', landlordDesc: 'किराये की आय',
      crypto: 'क्रिप्टो धारक', cryptoDesc: 'डिजिटल संपत्ति',
      livestock: 'पशुधन स्वामी', livestockDesc: 'जानवर और उत्पाद',
      professional: 'पेशेवर', professionalDesc: 'डॉक्टर, वकील आदि',
    },
    calculator: {
      step1: 'श्रेणी चुनें', step2: 'संपत्ति', step3: 'कटौती', step4: 'परिणाम',
      next: 'आगे', back: 'पीछे', calculate: 'ज़कात की गणना करें', reset: 'रीसेट',
      gold: 'सोना', silver: 'चांदी', cash: 'नक़द और बचत', investments: 'निवेश',
      business: 'व्यापारिक संपत्ति', crypto: 'क्रिप्टोकरेंसी', livestock: 'पशुधन', agriculture: 'कृषि',
      pension: 'पेंशन', jewellery: 'आभूषण', receivables: 'देय राशियाँ', inventory: 'स्टॉक',
      debts: 'व्यक्तिगत ऋण', expenses: 'आवश्यक खर्च', liabilities: 'व्यापारिक देनदारियाँ',
    },
    results: {
      totalAssets: 'कुल संपत्ति', totalDeductions: 'कुल कटौतियाँ', netZakatable: 'ज़कात-योग्य कुल',
      nisabThreshold: 'निसाब सीमा', zakatDue: 'देय ज़कात', eligible: 'ज़कात अनिवार्य',
      notEligible: 'निसाब से कम', breakdown: 'विवरण', downloadReport: 'रिपोर्ट डाउनलोड करें', shareResult: 'साझा करें',
    },
    rulings: {
      title: 'विद्वानों के फ़तवे',
      subtitle: 'ज़कात पर विभिन्न मज़हबों के विचार',
      hanafi: 'हनफ़ी', maliki: 'मालिकी', shafii: 'शाफ़ई', hanbali: 'हंबली',
      aaoifi: 'AAOIFI मानक', contemporary: 'समकालीन उलमा',
    },
    faq: {
      title: 'अक्सर पूछे जाने वाले प्रश्न',
      q1: 'क्या महिलाओं के आभूषणों पर ज़कात है?',
      a1: 'हनफ़ी मज़हब के अनुसार, अगर सोने/चांदी के आभूषण निसाब तक पहुँचते हैं तो उन पर ज़कात है। अन्य मज़हब नियमित पहने जाने वाले आभूषणों को छूट देते हैं।',
      q2: 'पेंशन निधियों पर ज़कात कैसे निकाली जाए?',
      a2: 'सुलभ पेंशन निधियों पर पूरी राशि पर ज़कात है। बंद निधियों (जैसे EPF) पर निकासी के समय ज़कात है।',
      q3: 'क्या क्रिप्टोकरेंसी पर ज़कात है?',
      a3: 'हाँ, क्रिप्टोकरेंसी को व्यापारिक माल माना जाता है। एक चांद्र वर्ष तक रखने पर बाज़ार मूल्य पर ज़कात है।',
      q4: 'सोने या चांदी का निसाब चुनें?',
      a4: 'विद्वान चांदी के निसाब को बेहतर मानते हैं ताकि अधिक ज़रूरतमंदों को लाभ हो। सोने का निसाब भी मान्य है।',
      q5: 'व्यावसायिक साझेदार ज़कात कैसे निकालें?',
      a5: 'प्रत्येक साझेदार अपनी देनदारियों के हिस्से को घटाकर अपनी संपत्ति के हिस्से पर ज़कात निकाले।',
    },
    common: { loading: 'लोड हो रहा है...', error: 'त्रुटि', perGram: 'प्रति ग्राम', total: 'कुल', currency: 'मुद्रा', country: 'देश', selectCountry: 'देश चुनें', selectLanguage: 'भाषा चुनें',
      step: 'चरण',
      quickAnswer: 'त्वरित उत्तर',
      directSummary: 'सीधा सारांश'
    },
    steps: {
      estate: 'संपत्ति',
      deductions: 'कटौतियाँ',
      heirs: 'वारिस',
      result: 'परिणाम'
    },
  },

  bn: {
    nav: { home: 'হোম', calculator: 'যাকাত ক্যালকুলেটর', rulings: 'ফতোয়া', giving: 'দান', faq: 'সাধারণ প্রশ্ন', language: 'ভাষা' , logoTitle: 'যাকাত ইন্টারন্যাশনাল', learn: 'শিখুন', laws: 'আইন', women: 'নারী' },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'যাকাত ইন্টারন্যাশনাল',
      subtitle: 'সর্বজনীন যাকাত ক্যালকুলেটর',
      description: 'বিভিন্ন দেশ, মুদ্রা এবং ব্যক্তিগত পরিস্থিতি অনুসারে আপনার যাকাত নির্ভুলভাবে হিসাব করুন।',
      startCalculator: 'ক্যালকুলেটর শুরু করুন',
      learnMore: 'আরও জানুন',
    },
    stats: { goldNisab: 'স্বর্ণের নিসাব', silverNisab: 'রুপার নিসাব', zakatRate: 'যাকাতের হার', grams: 'গ্রাম', livePrice: 'লাইভ মূল্য' },
    personTypes: {
      title: 'আপনার বিভাগ নির্বাচন করুন',
      subtitle: 'ব্যক্তিগতকৃত হিসাবের জন্য আপনার পরিস্থিতি বেছে নিন',
      salaried: 'বেতনভোগী কর্মচারী', salariedDesc: 'চাকরি থেকে নিয়মিত আয়',
      selfEmployed: 'স্ব-নিযুক্ত', selfEmployedDesc: 'ফ্রিল্যান্সার বা পরামর্শক',
      businessOwner: 'ব্যবসা মালিক', businessOwnerDesc: 'খুচরা, হোটেল বা সেবা',
      investor: 'বিনিয়োগকারী', investorDesc: 'শেয়ার, মিউচুয়াল ফান্ড, ক্রিপ্টো',
      farmer: 'কৃষক', farmerDesc: 'কৃষি আয়',
      retiree: 'অবসরপ্রাপ্ত', retireeDesc: 'পেনশন ও সঞ্চয়',
      student: 'ছাত্র', studentDesc: 'সঞ্চয় ও বৃত্তি',
      women: 'মহিলা', womenDesc: 'গয়না ও মাহর',
      landlord: 'বাড়িওয়ালা', landlordDesc: 'ভাড়া আয়',
      crypto: 'ক্রিপ্টো ধারক', cryptoDesc: 'ডিজিটাল সম্পদ',
      livestock: 'গবাদি পশু মালিক', livestockDesc: 'পশু ও উৎপাদন',
      professional: 'পেশাদার', professionalDesc: 'ডাক্তার, আইনজীবী ইত্যাদি',
    },
    calculator: {
      step1: 'বিভাগ নির্বাচন', step2: 'সম্পদ', step3: 'বাদ', step4: 'ফলাফল',
      next: 'পরবর্তী', back: 'পূর্ববর্তী', calculate: 'যাকাত হিসাব করুন', reset: 'রিসেট',
      gold: 'স্বর্ণ', silver: 'রুপা', cash: 'নগদ ও সঞ্চয়', investments: 'বিনিয়োগ',
      business: 'ব্যবসায়িক সম্পদ', crypto: 'ক্রিপ্টোকারেন্সি', livestock: 'গবাদি পশু', agriculture: 'কৃষি',
      pension: 'পেনশন', jewellery: 'অলঙ্কার', receivables: 'প্রাপ্য', inventory: 'মজুদ',
      debts: 'ব্যক্তিগত ঋণ', expenses: 'প্রয়োজনীয় ব্যয়', liabilities: 'ব্যবসায়িক দায়',
    },
    results: {
      totalAssets: 'মোট সম্পদ', totalDeductions: 'মোট বাদ', netZakatable: 'নিট যাকাতযোগ্য',
      nisabThreshold: 'নিসাব সীমা', zakatDue: 'প্রদেয় যাকাত', eligible: 'যাকাত প্রযোজ্য',
      notEligible: 'নিসাবের নিচে', breakdown: 'বিস্তারিত', downloadReport: 'রিপোর্ট ডাউনলোড', shareResult: 'শেয়ার করুন',
    },
    rulings: {
      title: 'আলেমদের ফতোয়া',
      subtitle: 'যাকাত সম্পর্কে বিভিন্ন মাযহাবের অভিমত',
      hanafi: 'হানাফী', maliki: 'মালিকী', shafii: 'শাফেয়ী', hanbali: 'হাম্বলী',
      aaoifi: 'AAOIFI মানদণ্ড', contemporary: 'সমকালীন আলেম',
    },
    faq: {
      title: 'প্রায়শই জিজ্ঞাসিত প্রশ্ন',
      q1: 'মহিলাদের গয়নায় কি যাকাত প্রযোজ্য?',
      a1: 'হানাফী মাযহাব অনুযায়ী, স্বর্ণ/রুপার গয়না নিসাব পরিমাণ হলে যাকাত প্রযোজ্য। অন্য মাযহাবে নিয়মিত পরিধেয় গয়না ব্যতীত।',
      q2: 'পেনশন ফান্ডে কীভাবে যাকাত নির্ধারিত হয়?',
      a2: 'উন্মুক্ত পেনশন ফান্ডের পূর্ণ পরিমাণে যাকাত প্রযোজ্য। লকড ফান্ডে (যেমন EPF) উত্তোলনের সময়।',
      q3: 'ক্রিপ্টোকারেন্সি কি যাকাত যোগ্য?',
      a3: 'হ্যাঁ, ক্রিপ্টোকে ব্যবসায়িক পণ্য হিসেবে গণ্য করা হয়। এক চান্দ্রবছর ধরে রাখলে বাজার মূল্যে যাকাত প্রযোজ্য।',
      q4: 'স্বর্ণ না রুপার নিসাব ব্যবহার করব?',
      a4: 'আলেমগণ রুপার নিসাব ব্যবহারের পরামর্শ দেন যাতে বেশি অভাবী উপকৃত হন। স্বর্ণের নিসাবও বৈধ।',
      q5: 'ব্যবসায়িক অংশীদারগণ কীভাবে যাকাত হিসাব করবে?',
      a5: 'প্রতিটি অংশীদার তার দায়ের অংশ বাদ দিয়ে তার সম্পদের অংশের ওপর যাকাত হিসাব করবে।',
    },
    common: { loading: 'লোড হচ্ছে...', error: 'ত্রুটি', perGram: 'প্রতি গ্রাম', total: 'মোট', currency: 'মুদ্রা', country: 'দেশ', selectCountry: 'দেশ নির্বাচন করুন', selectLanguage: 'ভাষা নির্বাচন করুন',
      step: 'ধাপ',
      quickAnswer: 'দ্রুত উত্তর',
      directSummary: 'সরাসরি সারাংশ'
    },
    steps: {
      estate: 'সম্পত্তি',
      deductions: 'কর্তন',
      heirs: 'উত্তরাধিকারী',
      result: 'ফলাফল'
    },
  },

  ml: {
    nav: { home: 'ഹോം', calculator: 'സകാത്ത് കാൽക്കുലേറ്റർ', rulings: 'ഫത്‌വകൾ', giving: 'ദാനം', faq: 'പതിവ് ചോദ്യങ്ങൾ', language: 'ഭാഷ' , logoTitle: 'സകാത്ത് ഇന്റർനാഷണൽ', learn: 'പഠിക്കുക', laws: 'നിയമങ്ങൾ', women: 'സ്ത്രീകൾ' },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'സകാത്ത് ഇന്റർനാഷണൽ',
      subtitle: 'യൂണിവേഴ്സൽ സകാത്ത് കാൽക്കുലേറ്റർ',
      description: 'വിവിധ രാജ്യങ്ങൾ, കറൻസികൾ, വ്യക്തിഗത സാഹചര്യങ്ങൾ എന്നിവ കണക്കിലെടുത്ത് നിങ്ങളുടെ സകാത്ത് കൃത്യമായി കണക്കാക്കുക.',
      startCalculator: 'കാൽക്കുലേറ്റർ ആരംഭിക്കുക',
      learnMore: 'കൂടുതൽ അറിയുക',
    },
    stats: { goldNisab: 'സ്വർണ്ണ നിസാബ്', silverNisab: 'വെള്ളി നിസാബ്', zakatRate: 'സകാത്ത് നിരക്ക്', grams: 'ഗ്രാം', livePrice: 'ലൈവ് വില' },
    personTypes: {
      title: 'നിങ്ങളുടെ വിഭാഗം തിരഞ്ഞെടുക്കുക',
      subtitle: 'വ്യക്തിഗത കണക്കുകൂട്ടലിനായി നിങ്ങളുടെ സാഹചര്യം തിരഞ്ഞെടുക്കുക',
      salaried: 'ശമ്പളക്കാരൻ', salariedDesc: 'തൊഴിലിൽ നിന്ന് സ്ഥിര വരുമാനം',
      selfEmployed: 'സ്വയം തൊഴിലുള്ളവൻ', selfEmployedDesc: 'ഫ്രീലാൻസർ അല്ലെങ്കിൽ കൺസൾട്ടന്റ്',
      businessOwner: 'ബിസിനസ് ഉടമ', businessOwnerDesc: 'റീട്ടെയിൽ, ഹോട്ടൽ, അല്ലെങ്കിൽ സേവനങ്ങൾ',
      investor: 'നിക്ഷേപകൻ', investorDesc: 'ഓഹരി, മ്യൂച്വൽ ഫണ്ട്, ക്രിപ്റ്റോ',
      farmer: 'കർഷകൻ', farmerDesc: 'കാർഷിക വരുമാനം',
      retiree: 'വിരമിച്ചയാൾ', retireeDesc: 'പെൻഷനും സമ്പാദ്യവും',
      student: 'വിദ്യാർത്ഥി', studentDesc: 'സമ്പാദ്യവും സ്കോളർഷിപ്പുകളും',
      women: 'സ്ത്രീകൾ', womenDesc: 'ആഭരണങ്ങളും മഹറും',
      landlord: 'ഭൂവുടമ', landlordDesc: 'വാടക വരുമാനം',
      crypto: 'ക്രിപ്റ്റോ ഉടമ', cryptoDesc: 'ഡിജിറ്റൽ ആസ്തി',
      livestock: 'കന്നുകാലി ഉടമ', livestockDesc: 'മൃഗങ്ങളും ഉൽപ്പന്നങ്ങളും',
      professional: 'പ്രൊഫഷണൽ', professionalDesc: 'ഡോക്ടർ, വക്കീൽ മുതലായവ',
    },
    calculator: {
      step1: 'വിഭാഗം തിരഞ്ഞെടുക്കുക', step2: 'ആസ്തികൾ', step3: 'കിഴിവ്', step4: 'ഫലങ്ങൾ',
      next: 'അടുത്തത്', back: 'പിന്നോട്ട്', calculate: 'സകാത്ത് കണക്കാക്കുക', reset: 'റീസെറ്റ്',
      gold: 'സ്വർണ്ണം', silver: 'വെള്ളി', cash: 'പണവും സമ്പാദ്യവും', investments: 'നിക്ഷേപങ്ങൾ',
      business: 'വ്യാപാര ആസ്തി', crypto: 'ക്രിപ്റ്റോകറൻസി', livestock: 'കന്നുകാലികൾ', agriculture: 'കൃഷി',
      pension: 'പെൻഷൻ', jewellery: 'ആഭരണങ്ങൾ', receivables: 'കിട്ടാനുള്ളവ', inventory: 'സ്റ്റോക്ക്',
      debts: 'വ്യക്തിഗത കടം', expenses: 'അവശ്യ ചെലവുകൾ', liabilities: 'വ്യാപാര ബാധ്യതകൾ',
    },
    results: {
      totalAssets: 'മൊത്തം ആസ്തി', totalDeductions: 'മൊത്തം കിഴിവ്', netZakatable: 'നെറ്റ് സകാത്ത് യോഗ്യം',
      nisabThreshold: 'നിസാബ് പരിധി', zakatDue: 'നൽകേണ്ട സകാത്ത്', eligible: 'സകാത്ത് നിർബന്ധം',
      notEligible: 'നിസാബിന് താഴെ', breakdown: 'വിശദാംശങ്ങൾ', downloadReport: 'റിപ്പോർട്ട് ഡൗൺലോഡ്', shareResult: 'പങ്കിടുക',
    },
    rulings: {
      title: 'പണ്ഡിതന്മാരുടെ ഫത്‌വകൾ',
      subtitle: 'സകാത്ത് സംബന്ധിച്ച വിവിധ മദ്ഹബുകളുടെ വീക്ഷണങ്ങൾ',
      hanafi: 'ഹനഫി', maliki: 'മാലികി', shafii: 'ശാഫിഈ', hanbali: 'ഹന്ബലി',
      aaoifi: 'AAOIFI സ്റ്റാൻഡേർഡ്', contemporary: 'സമകാലിക പണ്ഡിതന്മാർ',
    },
    faq: {
      title: 'പതിവ് ചോദ്യങ്ങൾ',
      q1: 'സ്ത്രീകളുടെ ആഭരണങ്ങൾക്ക് സകാത്ത് നൽകേണ്ടതുണ്ടോ?',
      a1: 'ഹനഫി മദ്ഹബ് അനുസരിച്ച്, സ്വർണ്ണ/വെള്ളി ആഭരണങ്ങൾ നിസാബ് എത്തിയാൽ സകാത്ത് നൽകണം. മറ്റ് മദ്ഹബുകൾ പതിവായി ധരിക്കുന്നവയ്ക്ക് ഇളവ് നൽകുന്നു.',
      q2: 'പെൻഷൻ ഫണ്ടുകൾക്ക് സകാത്ത് എങ്ങനെ കണക്കാക്കും?',
      a2: 'ലഭ്യമായ ഫണ്ടുകൾക്ക് മുഴുവൻ തുകയ്ക്കും സകാത്ത്. ലോക്കിലുള്ളവയ്ക്ക് (EPF പോലുള്ളവ) പിൻവലിക്കുമ്പോൾ.',
      q3: 'ക്രിപ്റ്റോകറൻസിക്ക് സകാത്ത് ബാധകമാണോ?',
      a3: 'അതെ, ക്രിപ്റ്റോ വ്യാപാര വസ്തുവായി കണക്കാക്കുന്നു. ഒരു ചാന്ദ്ര വർഷം കൈവശം വച്ചാൽ വിപണി മൂല്യത്തിന് സകാത്ത് നൽകണം.',
      q4: 'സ്വർണ്ണത്തിന്റെയോ വെള്ളിയുടെയോ നിസാബ് ഉപയോഗിക്കണം?',
      a4: 'കൂടുതൽ ദരിദ്രർക്ക് ഉപകാരപ്പെടാൻ പണ്ഡിതന്മാർ വെള്ളി നിസാബ് ശുപാർശ ചെയ്യുന്നു. സ്വർണ്ണ നിസാബും സാധുവാണ്.',
      q5: 'ബിസിനസ് പങ്കാളികൾ എങ്ങനെ സകാത്ത് കണക്കാക്കും?',
      a5: 'ഓരോ പങ്കാളിയും തന്റെ ബാധ്യതാ വിഹിതം കിഴിച്ച ശേഷം ആസ്തി വിഹിതത്തിന് സകാത്ത് കണക്കാക്കണം.',
    },
    common: { loading: 'ലോഡ് ചെയ്യുന്നു...', error: 'പിശക്', perGram: 'ഒരു ഗ്രാമിന്', total: 'മൊത്തം', currency: 'കറൻസി', country: 'രാജ്യം', selectCountry: 'രാജ്യം തിരഞ്ഞെടുക്കുക', selectLanguage: 'ഭാഷ തിരഞ്ഞെടുക്കുക',
      step: 'ഘട്ടം',
      quickAnswer: 'വേഗ ഉത്തരം',
      directSummary: 'നേരിട്ട് സാരാംശം'
    },
    steps: {
      estate: 'എസ്റ്റേറ്റ്',
      deductions: 'കിഴിവുകൾ',
      heirs: 'അവകാശികൾ',
      result: 'ഫലം'
    },
  },

  id: {
    nav: { home: 'Beranda', calculator: 'Kalkulator Zakat', rulings: 'Fatwa', giving: 'Donasi', faq: 'Pertanyaan', language: 'Bahasa' , logoTitle: 'Amanah by Zakat.International', learn: 'Pelajari', laws: 'Hukum', women: 'Wanita' },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'Amanah by Zakat.International',
      subtitle: 'Kalkulator Zakat Universal',
      description: 'Hitung kewajiban zakat Anda dengan akurat untuk berbagai negara, mata uang, dan situasi pribadi.',
      startCalculator: 'Mulai Kalkulator',
      learnMore: 'Pelajari Lebih Lanjut',
    },
    stats: { goldNisab: 'Nisab Emas', silverNisab: 'Nisab Perak', zakatRate: 'Tarif Zakat', grams: 'gram', livePrice: 'Harga Langsung' },
    personTypes: {
      title: 'Pilih Kategori Anda',
      subtitle: 'Pilih situasi Anda untuk perhitungan yang dipersonalisasi',
      salaried: 'Karyawan Bergaji', salariedDesc: 'Pendapatan tetap dari pekerjaan',
      selfEmployed: 'Wiraswasta', selfEmployedDesc: 'Pekerja lepas atau konsultan',
      businessOwner: 'Pemilik Usaha', businessOwnerDesc: 'Ritel, hotel, atau jasa',
      investor: 'Investor', investorDesc: 'Saham, reksa dana, kripto',
      farmer: 'Petani', farmerDesc: 'Pendapatan pertanian',
      retiree: 'Pensiunan', retireeDesc: 'Pensiun dan tabungan',
      student: 'Pelajar', studentDesc: 'Tabungan dan beasiswa',
      women: 'Perempuan', womenDesc: 'Perhiasan dan mahar',
      landlord: 'Pemilik Properti', landlordDesc: 'Pendapatan sewa',
      crypto: 'Pemegang Kripto', cryptoDesc: 'Aset digital',
      livestock: 'Peternak', livestockDesc: 'Hewan dan hasil ternak',
      professional: 'Profesional', professionalDesc: 'Dokter, pengacara, dll.',
    },
    calculator: {
      step1: 'Pilih Kategori', step2: 'Aset', step3: 'Pengurangan', step4: 'Hasil',
      next: 'Lanjut', back: 'Kembali', calculate: 'Hitung Zakat', reset: 'Atur Ulang',
      gold: 'Emas', silver: 'Perak', cash: 'Uang & Tabungan', investments: 'Investasi',
      business: 'Aset Bisnis', crypto: 'Mata Uang Kripto', livestock: 'Ternak', agriculture: 'Pertanian',
      pension: 'Pensiun', jewellery: 'Perhiasan', receivables: 'Piutang', inventory: 'Persediaan',
      debts: 'Utang Pribadi', expenses: 'Biaya Pokok', liabilities: 'Kewajiban Bisnis',
    },
    results: {
      totalAssets: 'Total Aset', totalDeductions: 'Total Pengurangan', netZakatable: 'Bersih Wajib Zakat',
      nisabThreshold: 'Batas Nisab', zakatDue: 'Zakat Terutang', eligible: 'Wajib Zakat',
      notEligible: 'Di Bawah Nisab', breakdown: 'Rincian', downloadReport: 'Unduh Laporan', shareResult: 'Bagikan',
    },
    rulings: {
      title: 'Fatwa Para Ulama',
      subtitle: 'Pandangan berbagai mazhab tentang Zakat',
      hanafi: 'Hanafi', maliki: 'Maliki', shafii: 'Syafi\u2018i', hanbali: 'Hambali',
      aaoifi: 'Standar AAOIFI', contemporary: 'Ulama Kontemporer',
    },
    faq: {
      title: 'Pertanyaan yang Sering Diajukan',
      q1: 'Apakah perhiasan wanita wajib dizakati?',
      a1: 'Menurut mazhab Hanafi, perhiasan emas/perak wajib dizakati jika mencapai nisab. Mazhab lain mengecualikan perhiasan yang dipakai sehari-hari.',
      q2: 'Bagaimana cara menghitung zakat dana pensiun?',
      a2: 'Untuk dana yang dapat diakses, zakat dikenakan atas seluruh jumlah. Untuk dana terkunci (seperti BPJS) zakat saat penarikan.',
      q3: 'Apakah kriptocurrency dikenai zakat?',
      a3: 'Ya, kripto diperlakukan sebagai barang dagangan. Zakat dikenakan pada nilai pasar setelah satu tahun hijriah.',
      q4: 'Saya pakai nisab emas atau perak?',
      a4: 'Para ulama menganjurkan nisab perak agar lebih banyak fakir miskin yang terbantu. Nisab emas juga sah.',
      q5: 'Bagaimana mitra bisnis menghitung zakat?',
      a5: 'Setiap mitra menghitung zakat atas bagian aset bisnis setelah dikurangi bagian kewajibannya.',
    },
    common: { loading: 'Memuat...', error: 'Kesalahan', perGram: 'per gram', total: 'Total', currency: 'Mata Uang', country: 'Negara', selectCountry: 'Pilih Negara', selectLanguage: 'Pilih Bahasa',
      step: 'Langkah',
      quickAnswer: 'Jawaban Cepat',
      directSummary: 'Ringkasan langsung'
    },
    steps: {
      estate: 'Harta warisan',
      deductions: 'Pengurangan',
      heirs: 'Ahli waris',
      result: 'Hasil'
    },
  },

  fa: {
    nav: { home: 'خانه', calculator: 'محاسبه‌گر زکات', rulings: 'فتاوا', giving: 'صدقات', faq: 'سوالات متداول', language: 'زبان' , logoTitle: 'زکات بین‌المللی', learn: 'یادگیری', laws: 'قوانین', women: 'زنان' },
    hero: {
      bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
      title: 'زکات بین‌المللی',
      subtitle: 'محاسبه‌گر جامع زکات',
      description: 'مقدار زکات خود را به صورت دقیق برای کشورها، ارزها و موقعیت‌های مختلف محاسبه کنید.',
      startCalculator: 'شروع محاسبه',
      learnMore: 'بیشتر بدانید',
    },
    stats: { goldNisab: 'نصاب طلا', silverNisab: 'نصاب نقره', zakatRate: 'نرخ زکات', grams: 'گرم', livePrice: 'قیمت زنده' },
    personTypes: {
      title: 'دسته‌بندی خود را انتخاب کنید',
      subtitle: 'وضعیت خود را برای محاسبه شخصی‌سازی شده انتخاب کنید',
      salaried: 'حقوق‌بگیر', salariedDesc: 'درآمد ثابت از شغل',
      selfEmployed: 'خویش‌فرما', selfEmployedDesc: 'مشاور یا فریلنسر',
      businessOwner: 'صاحب کسب‌وکار', businessOwnerDesc: 'خرده‌فروشی، هتل، خدمات',
      investor: 'سرمایه‌گذار', investorDesc: 'سهام، صندوق، ارز دیجیتال',
      farmer: 'کشاورز', farmerDesc: 'درآمد کشاورزی',
      retiree: 'بازنشسته', retireeDesc: 'حقوق بازنشستگی و پس‌انداز',
      student: 'دانشجو', studentDesc: 'پس‌انداز و بورسیه',
      women: 'بانوان', womenDesc: 'جواهرات و مهریه',
      landlord: 'مالک املاک', landlordDesc: 'درآمد اجاره',
      crypto: 'دارنده ارز دیجیتال', cryptoDesc: 'دارایی‌های دیجیتال',
      livestock: 'دامدار', livestockDesc: 'احشام و محصولات دامی',
      professional: 'حرفه‌ای', professionalDesc: 'پزشک، وکیل و غیره',
    },
    calculator: {
      step1: 'انتخاب دسته', step2: 'دارایی‌ها', step3: 'کسورات', step4: 'نتیجه',
      next: 'بعدی', back: 'قبلی', calculate: 'محاسبه زکات', reset: 'بازنشانی',
      gold: 'طلا', silver: 'نقره', cash: 'وجه نقد و پس‌انداز', investments: 'سرمایه‌گذاری',
      business: 'دارایی‌های تجاری', crypto: 'ارز دیجیتال', livestock: 'احشام', agriculture: 'کشاورزی',
      pension: 'بازنشستگی', jewellery: 'جواهرات', receivables: 'مطالبات', inventory: 'موجودی انبار',
      debts: 'بدهی‌های شخصی', expenses: 'هزینه‌های اساسی', liabilities: 'بدهی‌های تجاری',
    },
    results: {
      totalAssets: 'جمع دارایی‌ها', totalDeductions: 'جمع کسورات', netZakatable: 'مبلغ مشمول زکات',
      nisabThreshold: 'حد نصاب', zakatDue: 'زکات واجب', eligible: 'مشمول زکات',
      notEligible: 'کمتر از نصاب', breakdown: 'جزئیات', downloadReport: 'دانلود گزارش', shareResult: 'اشتراک‌گذاری',
    },
    rulings: {
      title: 'فتاوای علما',
      subtitle: 'دیدگاه‌های مذاهب مختلف درباره زکات',
      hanafi: 'حنفی', maliki: 'مالکی', shafii: 'شافعی', hanbali: 'حنبلی',
      aaoifi: 'استاندارد AAOIFI', contemporary: 'علمای معاصر',
    },
    faq: {
      title: 'سوالات متداول',
      q1: 'آیا زکات بر جواهرات زنان واجب است؟',
      a1: 'بنا بر مذهب حنفی، جواهرات طلا و نقره در صورت رسیدن به نصاب مشمول زکات هستند. مذاهب دیگر جواهرات روزمره را معاف می‌دانند.',
      q2: 'چگونه زکات صندوق بازنشستگی محاسبه می‌شود؟',
      a2: 'برای وجوه قابل دسترس، زکات بر کل مبلغ تعلق می‌گیرد. برای وجوه قفل‌شده، زکات هنگام برداشت پرداخت می‌شود.',
      q3: 'آیا ارز دیجیتال مشمول زکات است؟',
      a3: 'بله، ارز دیجیتال به‌عنوان کالای تجاری تلقی می‌شود و پس از یک سال قمری، زکات بر ارزش بازار آن تعلق می‌گیرد.',
      q4: 'از نصاب طلا استفاده کنم یا نقره؟',
      a4: 'علما توصیه به استفاده از نصاب نقره می‌کنند تا نیازمندان بیشتری بهره‌مند شوند. نصاب طلا نیز معتبر است.',
      q5: 'شرکای تجاری چگونه زکات می‌پردازند؟',
      a5: 'هر شریک زکات سهم خود از دارایی‌های تجاری را پس از کسر بدهی‌های متناظر محاسبه می‌کند.',
    },
    common: { loading: 'در حال بارگذاری...', error: 'خطا', perGram: 'هر گرم', total: 'مجموع', currency: 'ارز', country: 'کشور', selectCountry: 'انتخاب کشور', selectLanguage: 'انتخاب زبان',
      step: 'گام',
      quickAnswer: 'پاسخ سریع',
      directSummary: 'خلاصه مستقیم'
    },
    steps: {
      estate: 'دارایی',
      deductions: 'کسورات',
      heirs: 'وارثان',
      result: 'نتیجه'
    },
  },
  prs: {
  "nav": {
    "home": "خانه",
    "calculator": "محاسبه‌گر Zakat",
    "rulings": "احکام",
    "giving": "پرداخت",
    "faq": "سوالات متداول",
    "language": "زبان",
    "logoTitle": "Amanah by Zakat.International",
    "learn": "یادگیری", "laws": "قوانین", "women": "زنان"
  },
  "hero": {
    "bismillah": "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ",
    "title": "Amanah by Zakat.International",
    "subtitle": "محاسبه‌گر جهانی Zakat",
    "description": "تعهد زکات خود را با دقت در کشورهای مختلف، ارزها و شرایط شخصی محاسبه نمایید.",
    "startCalculator": "شروع محاسبه",
    "learnMore": "بیشتر بدانید"
  },
  "stats": {
    "goldNisab": "Nisab طلا",
    "silverNisab": "Nisab نقره",
    "zakatRate": "نرخ Zakat",
    "grams": "گرام",
    "livePrice": "قیمت زنده"
  },
  "personTypes": {
    "title": "دسته خود را انتخاب کنید",
    "subtitle": "وضعیت خود را برای محاسبه شخصی انتخاب نمایید",
    "salaried": "کارمند معاش‌دار",
    "salariedDesc": "عاید منظم از استخدام",
    "selfEmployed": "خود اشتغال",
    "selfEmployedDesc": "آزاد کار یا مشاور",
    "businessOwner": "صاحب کسب و کار",
    "businessOwnerDesc": "خرده فروشی، هوتل یا خدمات",
    "investor": "سرمایه‌گذار",
    "investorDesc": "سهام، صندوق‌های مشترک، کریپتو",
    "farmer": "کشاورز",
    "farmerDesc": "عاید زراعتی",
    "retiree": "بازنشسته",
    "retireeDesc": "معاش و پس‌انداز",
    "student": "محصل",
    "studentDesc": "پس‌انداز و بورسیه",
    "women": "خانم‌ها",
    "womenDesc": "زیورات و مهر",
    "landlord": "مالک ملکیت",
    "landlordDesc": "عاید کرایه",
    "crypto": "دارنده کریپتو",
    "cryptoDesc": "دارایی‌های دیجیتال",
    "livestock": "صاحب مواشی",
    "livestockDesc": "حیوانات و محصولات",
    "professional": "متخصص",
    "professionalDesc": "داکتر، وکیل و غیره"
  },
  "calculator": {
    "step1": "انتخاب نوع",
    "step2": "دارایی‌ها را وارد کنید",
    "step3": "کسورات",
    "step4": "نتایج",
    "next": "بعدی",
    "back": "قبلی",
    "calculate": "محاسبه Zakat",
    "reset": "از نو",
    "gold": "طلا",
    "silver": "نقره",
    "cash": "نقدی و پس‌انداز",
    "investments": "سرمایه‌گذاری‌ها",
    "business": "دارایی‌های تجارتی",
    "crypto": "ارز دیجیتال",
    "livestock": "مواشی",
    "agriculture": "زراعتی",
    "pension": "معاش",
    "jewellery": "زیورات",
    "receivables": "مطالبات",
    "inventory": "موجودی کالا",
    "debts": "قرضه‌های شخصی",
    "expenses": "مصارف ضروری",
    "liabilities": "بدهی‌های تجارتی"
  },
  "results": {
    "totalAssets": "مجموع دارایی‌ها",
    "totalDeductions": "مجموع کسورات",
    "netZakatable": "ثروت خالص مشمول Zakat",
    "nisabThreshold": "آستانه Nisab",
    "zakatDue": "Zakat واجب",
    "eligible": "Zakat واجب است",
    "notEligible": "کمتر از آستانه Nisab",
    "breakdown": "جزئیات",
    "downloadReport": "دانلود گزارش",
    "shareResult": "به اشتراک گذاشتن نتیجه"
  },
  "rulings": {
    "title": "احکام علمای دین",
    "subtitle": "مکاتب مختلف فقهی در مورد Zakat",
    "hanafi": "حنفی",
    "maliki": "مالکی",
    "shafii": "شافعی",
    "hanbali": "حنبلی",
    "aaoifi": "معیار AAOIFI",
    "contemporary": "علمای معاصر"
  },
  "faq": {
    "title": "سوالات متداول",
    "q1": "آیا بر زیورات خانم‌ها Zakat واجب است؟",
    "a1": "طبق مکتب حنفی، اگر زیورات طلا یا نقره به حد Nisab برسد، Zakat بر آن واجب است. مکاتب دیگر زیوراتی را که به طور منظم پوشیده می‌شود معاف می‌دانند.",
    "q2": "چگونه Zakat بر صندوق معاش محاسبه شود؟",
    "a2": "برای صندوق‌های معاش قابل دسترس، Zakat بر کل مبلغ واجب است. برای صندوق‌های قفل شده (مانند EPF)، Zakat زمانی واجب می‌شود که برداشت شود.",
    "q3": "آیا ارز دیجیتال مشمول Zakat است؟",
    "a3": "بلی، ارز دیجیتال به عنوان کالای قابل تجارت در نظر گرفته می‌شود. اگر به مدت یک سال قمری نگهداری شود، Zakat بر ارزش بازار آن واجب است.",
    "q4": "آیا باید از Nisab طلا یا نقره استفاده کنم؟",
    "a4": "علما توصیه می‌کنند از Nisab نقره استفاده شود تا فقیران بیشتری سود ببرند. با این حال، Nisab طلا نیز معتبر است.",
    "q5": "شرکای تجارتی چگونه Zakat را محاسبه می‌کنند؟",
    "a5": "هر شریک Zakat را بر سهم خود از دارایی‌های تجارتی پس از کسر سهم خود از بدهی‌ها محاسبه می‌کند."
  },
  "common": {
    "loading": "در حال بارگذاری...",
    "error": "خطا",
    "perGram": "فی گرام",
    "total": "مجموع",
    "currency": "واحد پول",
    "country": "کشور",
    "selectCountry": "کشور را انتخاب کنید",
    "selectLanguage": "زبان را انتخاب کنید",
      "step": "گام",
      "quickAnswer": "پاسخ سریع",
      "directSummary": "خلاصه مستقیم"
    },
    "steps": {
      "estate": "دارایی",
      "deductions": "کسورات",
      "heirs": "وارثان",
      "result": "نتیجه"
    }
},
  sw: {
  "nav": {
    "home": "Nyumbani",
    "calculator": "Kikokotoo cha Zakat",
    "rulings": "Hukumu",
    "giving": "Kutoa",
    "faq": "Maswali Yanayoulizwa Mara kwa Mara",
    "language": "Lugha",
    "logoTitle": "Amanah by Zakat.International",
    "learn": "Jifunze", "laws": "Sheria", "women": "Wanawake"
  },
  "hero": {
    "bismillah": "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ",
    "title": "Amanah by Zakat.International",
    "subtitle": "Kikokotoo cha Zakat cha Ulimwengu",
    "description": "Kokotoa wajibu wako wa zakat kwa usahihi katika nchi nyingi, sarafu, na hali za kibinafsi.",
    "startCalculator": "Anza Kikokotoo",
    "learnMore": "Jifunze Zaidi"
  },
  "stats": {
    "goldNisab": "Nisab ya Dhahabu",
    "silverNisab": "Nisab ya Fedha",
    "zakatRate": "Kiwango cha Zakat",
    "grams": "gramu",
    "livePrice": "Bei ya Sasa"
  },
  "personTypes": {
    "title": "Chagua Aina Yako",
    "subtitle": "Chagua hali yako kwa hesabu maalum",
    "salaried": "Mfanyakazi Mwenye Mshahara",
    "salariedDesc": "Mapato ya kawaida kutoka ajira",
    "selfEmployed": "Mjiajiri wa Kibinafsi",
    "selfEmployedDesc": "Mhuru au mshauri",
    "businessOwner": "Mmiliki wa Biashara",
    "businessOwnerDesc": "Rejareja, hoteli, au huduma",
    "investor": "Mwekezaji",
    "investorDesc": "Hisa, mfuko wa pamoja, crypto",
    "farmer": "Mkulima",
    "farmerDesc": "Mapato ya kilimo",
    "retiree": "Mstaafu",
    "retireeDesc": "Pensheni na akiba",
    "student": "Mwanafunzi",
    "studentDesc": "Akiba na ufadhili",
    "women": "Wanawake",
    "womenDesc": "Vito na mahari",
    "landlord": "Mmiliki wa Mali",
    "landlordDesc": "Mapato ya kupangisha",
    "crypto": "Mmiliki wa Crypto",
    "cryptoDesc": "Mali za kidijitali",
    "livestock": "Mmiliki wa Mifugo",
    "livestockDesc": "Wanyama na mazao",
    "professional": "Mtaalamu",
    "professionalDesc": "Daktari, wakili, n.k."
  },
  "calculator": {
    "step1": "Chagua Aina",
    "step2": "Ingiza Mali",
    "step3": "Upungufu",
    "step4": "Matokeo",
    "next": "Inayofuata",
    "back": "Rudi",
    "calculate": "Kokotoa Zakat",
    "reset": "Weka Upya",
    "gold": "Dhahabu",
    "silver": "Fedha",
    "cash": "Fedha Taslimu na Akiba",
    "investments": "Uwekezaji",
    "business": "Mali za Biashara",
    "crypto": "Sarafu ya Kidijitali",
    "livestock": "Mifugo",
    "agriculture": "Kilimo",
    "pension": "Pensheni",
    "jewellery": "Vito",
    "receivables": "Madeni Yanayostahili",
    "inventory": "Hisa za Bidhaa",
    "debts": "Madeni ya Kibinafsi",
    "expenses": "Gharama Muhimu",
    "liabilities": "Madeni ya Biashara"
  },
  "results": {
    "totalAssets": "Jumla ya Mali",
    "totalDeductions": "Jumla ya Upungufu",
    "netZakatable": "Mali Halisi Inayostahili Zakat",
    "nisabThreshold": "Kizingiti cha Nisab",
    "zakatDue": "Zakat Inayostahili",
    "eligible": "Zakat ni wajibu",
    "notEligible": "Chini ya kizingiti cha Nisab",
    "breakdown": "Maelezo",
    "downloadReport": "Pakua Ripoti",
    "shareResult": "Shiriki Matokeo"
  },
  "rulings": {
    "title": "Hukumu za Wanazuoni",
    "subtitle": "Madrasa tofauti za fikra kuhusu Zakat",
    "hanafi": "Hanafi",
    "maliki": "Maliki",
    "shafii": "Shafii",
    "hanbali": "Hanbali",
    "aaoifi": "Kiwango cha AAOIFI",
    "contemporary": "Wanazuoni wa Kisasa"
  },
  "faq": {
    "title": "Maswali Yanayoulizwa Mara kwa Mara",
    "q1": "Je, zakat inastahili kwenye vito vya wanawake?",
    "a1": "Kulingana na madrasa ya Hanafi, zakat inastahili kwenye vito vya dhahabu/fedha ikiwa vimefikia nisab. Madrasa mengine husamehe vito vinavyovalishwa kila siku.",
    "q2": "Jinsi ya kukokotoa zakat kwenye mfuko wa pensheni?",
    "a2": "Kwa mfuko wa pensheni unaoweza kufikiwa, zakat inastahili kwenye kiasi chote. Kwa mfuko uliofungwa (kama EPF), zakat inastahili wakati wa kuchukua.",
    "q3": "Je, sarafu ya kidijitali inastahili zakat?",
    "a3": "Ndiyo, sarafu ya kidijitali inachukuliwa kama bidhaa zinazouzwa. Zakat inastahili kwa thamani ya soko ikiwa imeshikiliwa kwa mwaka wa kumwezi.",
    "q4": "Je, nitumie nisab ya dhahabu au fedha?",
    "a4": "Wanazuoni wanapendekeza kutumia nisab ya fedha ili kunufaisha watu maskini zaidi. Hata hivyo, nisab ya dhahabu pia ni halali.",
    "q5": "Washirika wa biashara wanakokotoaje zakat?",
    "a5": "Kila mshirika anakokotoa zakat kwenye fungu lake la mali za biashara baada ya kupunguza fungu lake la madeni."
  },
  "common": {
    "loading": "Inapakia...",
    "error": "Kosa",
    "perGram": "kwa gramu",
    "total": "Jumla",
    "currency": "Sarafu",
    "country": "Nchi",
    "selectCountry": "Chagua Nchi",
    "selectLanguage": "Chagua Lugha",
      "step": "Hatua",
      "quickAnswer": "Jibu la Haraka",
      "directSummary": "Muhtasari wa moja kwa moja"
    },
    "steps": {
      "estate": "Mali",
      "deductions": "Makato",
      "heirs": "Warithi",
      "result": "Matokeo"
    }
},
  uz: {
  "nav": {
    "home": "Bosh sahifa",
    "calculator": "Zakat Kalkulyatori",
    "rulings": "Hukmlari",
    "giving": "Berish",
    "faq": "Savol-Javob",
    "language": "Til",
    "logoTitle": "Amanah by Zakat.International",
    "learn": "O’rganish", "laws": "Qonunlar", "women": "Ayollar"
  },
  "hero": {
    "bismillah": "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ",
    "title": "Amanah by Zakat.International",
    "subtitle": "Universal Zakat Kalkulyatori",
    "description": "Ko'p mamlakatlar, valyutalar va shaxsiy holatlar bo'yicha zakat majburiyatingizni aniq hisoblang.",
    "startCalculator": "Kalkulyatorni boshlash",
    "learnMore": "Batafsil ma'lumot"
  },
  "stats": {
    "goldNisab": "Oltin Nisab",
    "silverNisab": "Kumush Nisab",
    "zakatRate": "Zakat stavkasi",
    "grams": "gramm",
    "livePrice": "Jonli narx"
  },
  "personTypes": {
    "title": "Toifangizni tanlang",
    "subtitle": "Shaxsiy hisoblash uchun vaziyatingizni tanlang",
    "salaried": "Ish haqi oluvchi xodim",
    "salariedDesc": "Ishdan muntazam daromad",
    "selfEmployed": "O'z-o'zini band qilgan",
    "selfEmployedDesc": "Frilanser yoki maslahatchi",
    "businessOwner": "Biznes egasi",
    "businessOwnerDesc": "Chakana savdo, mehmonxona yoki xizmatlar",
    "investor": "Investor",
    "investorDesc": "Aksiyalar, investitsiya fondlari, kripto",
    "farmer": "Fermer",
    "farmerDesc": "Qishloq xo'jaligi daromadi",
    "retiree": "Nafaqaxo'r",
    "retireeDesc": "Nafaqa va jamg'armalar",
    "student": "Talaba",
    "studentDesc": "Jamg'armalar va stipendiyalar",
    "women": "Ayollar/Xonimlar",
    "womenDesc": "Zargarlik buyumlari va mahr",
    "landlord": "Uy egasi",
    "landlordDesc": "Ijara daromadi",
    "crypto": "Kripto egalari",
    "cryptoDesc": "Raqamli aktivlar",
    "livestock": "Chorva egasi",
    "livestockDesc": "Hayvonlar va mahsulotlar",
    "professional": "Professional",
    "professionalDesc": "Shifokor, advokat va boshqalar"
  },
  "calculator": {
    "step1": "Turini tanlang",
    "step2": "Aktivlarni kiriting",
    "step3": "Chegirmalar",
    "step4": "Natijalar",
    "next": "Keyingisi",
    "back": "Orqaga",
    "calculate": "Zakatni hisoblash",
    "reset": "Qayta boshlash",
    "gold": "Oltin",
    "silver": "Kumush",
    "cash": "Naqd pul va jamg'armalar",
    "investments": "Investitsiyalar",
    "business": "Biznes aktivlari",
    "crypto": "Kriptovalyuta",
    "livestock": "Chorva",
    "agriculture": "Qishloq xo'jaligi",
    "pension": "Nafaqa",
    "jewellery": "Zargarlik buyumlari",
    "receivables": "Qarzlar",
    "inventory": "Tovar zahiralari",
    "debts": "Shaxsiy qarzlar",
    "expenses": "Asosiy xarajatlar",
    "liabilities": "Biznes majburiyatlari"
  },
  "results": {
    "totalAssets": "Jami aktivlar",
    "totalDeductions": "Jami chegirmalar",
    "netZakatable": "Sof zakatga tegishli boylik",
    "nisabThreshold": "Nisab chegarasi",
    "zakatDue": "To'lanishi kerak bo'lgan zakat",
    "eligible": "Zakat farz",
    "notEligible": "Nisab chegarasidan past",
    "breakdown": "Tafsilot",
    "downloadReport": "Hisobotni yuklab olish",
    "shareResult": "Natijani ulashish"
  },
  "rulings": {
    "title": "Olimarning hukmlari",
    "subtitle": "Zakat bo'yicha turli mazhablarning qarashlari",
    "hanafi": "Hanafiy",
    "maliki": "Molikiy",
    "shafii": "Shofеiy",
    "hanbali": "Hanbaliy",
    "aaoifi": "AAOIFI standarti",
    "contemporary": "Zamonaviy olimlar"
  },
  "faq": {
    "title": "Tez-tez so'raladigan savollar",
    "q1": "Ayollarning zargarlik buyumlariga zakat berilishi kerakmi?",
    "a1": "Hanafiy mazhabiga ko'ra, agar oltin/kumush zargarlik buyumlari nisabga yetsa, zakat beriladi. Boshqa mazhablarda doimiy taqiladigan zargarlik buyumlari zakat dan ozod qilinadi.",
    "q2": "Nafaqa fondlariga qanday zakat hisoblanadi?",
    "a2": "Foydalanish mumkin bo'lgan nafaqa fondlariga to'liq summadan zakat beriladi. EPF kabi bloklangan fondlar uchun zakat olinganda beriladi.",
    "q3": "Kriptovalyutaga zakat berilishi kerakmi?",
    "a3": "Ha, kriptovalyuta savdo qilinadigan mol sifatida qaraladi. Agar bir qamariiy yil saqlanilsa, bozor qiymatidan zakat beriladi.",
    "q4": "Oltin yoki kumush nisabidan foydalanishim kerakmi?",
    "a4": "Olimlar ko'proq kambag'allarga foyda yetkazish uchun kumush nisabini tavsiya qiladilar. Biroq, oltin nisabi ham to'g'ri.",
    "q5": "Biznes sheriklari zakatni qanday hisoblaydilar?",
    "a5": "Har bir sherik biznes aktivlarining o'z ulushiga zakat hisoblaydi, majburiyatlarning o'z ulushini ayirib."
  },
  "common": {
    "loading": "Yuklanmoqda...",
    "error": "Xato",
    "perGram": "har bir gramm uchun",
    "total": "Jami",
    "currency": "Valyuta",
    "country": "Mamlakat",
    "selectCountry": "Mamlakatni tanlang",
    "selectLanguage": "Tilni tanlang",
      "step": "Qadam",
      "quickAnswer": "Tezkor javob",
      "directSummary": "Toʻgʻridan-toʻgʻri xulosa"
    },
    "steps": {
      "estate": "Meros",
      "deductions": "Chegirmalar",
      "heirs": "Vorislar",
      "result": "Natija"
    }
},
};

export const getTranslation = (lang, path) => {
  // Try main translations first (nested object)
  const keys = path.split('.');
  let result = translations[lang] || translations.en;
  let fallback = translations.en;
  for (const key of keys) {
    result = result?.[key];
    fallback = fallback?.[key];
  }
  if (result !== undefined && result !== null) return result;
  // Fallback to translationsExt (flat dot-path map)
  const extHit = translationsExt?.[lang]?.[path] ?? translationsExt?.en?.[path];
  if (extHit !== undefined) return extHit;
  // Fallback to V2 homepage translations (flat dot-path map)
  const v2Hit = translationsV2?.[lang]?.[path] ?? translationsV2?.en?.[path];
  if (v2Hit !== undefined) return v2Hit;
  // Fallback to V2 extras (nav labels + FAQ Q&A)
  const v2xHit = translationsV2Extra?.[lang]?.[path] ?? translationsV2Extra?.en?.[path];
  if (v2xHit !== undefined) return v2xHit;
  // Fallback to V2 menu (DesktopMoreMenu section headers + items)
  const v2mHit = translationsV2Menu?.[lang]?.[path] ?? translationsV2Menu?.en?.[path];
  if (v2mHit !== undefined) return v2mHit;
  // Fallback to Succession Planning catalog
  const succHit = translationsSuccession?.[lang]?.[path] ?? translationsSuccession?.en?.[path];
  if (succHit !== undefined) return succHit;
  return fallback ?? path;
};
